/**
 * useThresholds — restituisce le soglie alert del tenant con fallback ai default.
 * Usato dai componenti dashboard per determinare lo status (positive/warning/critical)
 * delle KPICard in modo dinamico invece di usare valori hardcodati.
 */
import { KPIStatus } from '../components/ui/KPICard'
import { DEFAULT_THRESHOLDS, useTenant } from './useTenant'

export function useThresholds() {
  const { data: tenant } = useTenant()
  const t = { ...DEFAULT_THRESHOLDS, ...(tenant?.settings?.alert_thresholds ?? {}) }
  return t
}

// ── Helpers per calcolare lo status da un valore e soglie ────────────────────

/** Valore alto è positivo (es. margine, utilization, revenue vs budget) */
export function statusHighGood(
  value: number,
  positive: number,
  warning: number,
): KPIStatus {
  if (value >= positive) return 'positive'
  if (value >= warning) return 'warning'
  return 'critical'
}

/** Valore basso è positivo (es. DSO, crediti scaduti %) */
export function statusLowGood(
  value: number,
  positive: number,
  warning: number,
): KPIStatus {
  if (value <= positive) return 'positive'
  if (value <= warning) return 'warning'
  return 'critical'
}
